import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import http from '@/api/config'
import 'element-plus/dist/index.css'
import '../src/utils/index.css'
import './assets/css/icon.css'
import './assets/css/iconfont.css'
import Global from './utils/global'
import Upload from './utils/Upload'
import filter from './utils/filter'
import elementIcon from "./plugins/icons"
// markdown编辑器
//import VMdEditor from '@kangc/v-md-editor';
import VMdPreview from '@kangc/v-md-editor/lib/preview';
import '@kangc/v-md-editor/lib/style/base-editor.css';
import githubTheme from '@kangc/v-md-editor/lib/theme/github.js';
import '@kangc/v-md-editor/lib/theme/style/github.css';
import hljs from 'highlight.js'; // highlightjs
import 'wow.js/css/libs/animate.css'


// VMdEditor.use(githubTheme, {
//     Hljs: hljs,
// });


VMdPreview.use(githubTheme, {
  Hljs: hljs,
});

router.beforeEach((to, from, next) => {
    let time = new Date()
    let y = time.getFullYear()
    let m = time.getMonth() + 1
    m = m < 10 ? m : m
    let d = time.getDate()
    d = d < 10 ? '0' + d : d
    let h = time.getHours()
    h = h < 10 ? '0' + h : h
    let M = time.getMinutes()
    M = M < 10 ? '0' + M : M
    let s = time.getSeconds()
    s = s < 10 ? '0' + s : s
    let dateTime = y + '-' + m + '-' + d + ' ' + h + ':' + M + ':' + s
    let times = window.localStorage.getItem('tokenStartTime')
    let myDate = new Date(times)
    //年
    let yy = String(myDate.getFullYear())
    //月
    let mm = myDate.getMonth() + 1
    //日
    let dd = String(
      myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate()
    )
    //时
    let hou = String(
      myDate.getHours() < 10 ? '0' + myDate.getHours() : myDate.getHours()
    )
    //分
    let min = String(
      myDate.getMinutes() < 10 ? '0' + myDate.getMinutes() : myDate.getMinutes()
    )
    //秒
    let sec = String(
      myDate.getSeconds() < 10 ? '0' + myDate.getSeconds() : myDate.getSeconds()
    )
    times = yy + '-' + mm + '-' + dd + ' ' + hou + ':' + min + ':' + sec
    let token = null
    if (times < dateTime) {
      token = 0
    } else {
      token = 1
    }
    if (token == 0) {
      // this.$message.error("登录失效")
      localStorage.removeItem('ms_username')
      const role = localStorage.getItem('ms_username')
      if (!role && to.path == '/about') {
        next('/login')
      } else if (to.meta.permission) {
        // 如果是管理员权限则可进入，这里只是简单的模拟管理员权限而已
        role === 'admin' ? next() : next('/403')
      } else {
        next()
      }
    } else {
      const role = localStorage.getItem('ms_username')
      if (!role && to.path !== '/about') {
        next('/login')
      } else if (to.meta.permission) {
        // 如果是管理员权限则可进入，这里只是简单的模拟管理员权限而已
        role === 'admin' ? next() : next('/403')
      } else {
        next()
      }
    }
  })

const app = createApp(App)
app.use(store)
.use(ElementPlus)
.use(router)
.use(elementIcon)
.mount('#app')
app.use(VMdPreview)
app.config.globalProperties.$http = http
app.config.globalProperties.Global = Global
app.config.globalProperties.Upload = Upload
app.config.globalProperties.filter = filter
